import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TypeService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.stanthonyUrl}/stock/type`,{params:searchParams});
    }

    get(Id){
      return this.http.get(`${environment.stanthonyUrl}/stock/type/`+Id);
    }

    edit(Id,formData){
      return this.http.put(`${environment.stanthonyUrl}/stock/type/`+Id,formData);
    }

    create(formData){
      return this.http.post(`${environment.stanthonyUrl}/stock/type`,formData);
    }

    delete(Id){
      return this.http.delete(`${environment.stanthonyUrl}/stock/type/`+Id);
    }

}
